<template>
    <div class="details">
        <md-field>
            <label>How much are you borrowing?</label>
            <span class="md-prefix">₱</span>
            <md-input
                    v-model="principal"
                    @keyup="$emit('update:principal', principal);"
                    style="font-size: 24px">
            </md-input>
        </md-field>
        <b-collapse :open="false" aria-id="contentIdForA11y3">
            <div slot="trigger" slot-scope="props" role="button" aria-controls="contentIdForA11y3">
                <span class="is-size-7 has-text-grey-light">Optional</span>
                <p class="has-text-grey is-size-7">+ Interest, Due Date</p>
            </div>
            <div>
                <div>
                    <md-field>
                        <label>Propose an Interest Rate</label>
                        <md-input
                                v-model="interest"
                                @keyup="$emit('update:interest', interest);">
                        </md-input>
                        <span class="md-suffix">%</span>
                    </md-field>
                    <md-datepicker
                            v-model="due"
                            @input="$emit('update:due', due);">
                        <label>Set a Due Date</label>
                    </md-datepicker>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        name: "loan-details",
        props: ['principal','interest','due']
    }
</script>

<style scoped>
</style>